// 全局错误边界：局部渲染异常不再白屏/黑屏整个应用，提供重试出口
import { Component } from 'react';
import type { ErrorInfo, ReactNode } from 'react';
import { Button, Result } from 'antd';
import i18n from '../i18n';

interface State { error: Error | null }

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    // 前端异常留痕（后续可接集中日志）
    console.error('[wesc-ui] render crash:', error.message, info.componentStack?.slice(0, 300));
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    return (
      <Result
        status="error"
        style={{ paddingTop: 80 }}
        title={i18n.t('common.crash')}
        subTitle={error.message}
        extra={[
          <Button key="back" onClick={() => { this.setState({ error: null }); window.location.href = '/dashboard'; }}>
            {i18n.t('common.backHome')}
          </Button>,
          <Button key="retry" type="primary" onClick={() => this.setState({ error: null })}>
            {i18n.t('common.retry')}
          </Button>,
        ]}
      />
    );
  }
}
